module.exports = "https://web-assets.ifttt.com/packs/media/docs/trigger_field_location-11a726de.gif";